var map = {
	"./001_CEMC.json": 71305,
	"./002_WO.json": 97084,
	"./003_SCORE.json": 24555,
	"./004_NOSI.json": 90987,
	"./006_SDD.json": 64283,
	"./007_FR.json": 41519,
	"./COPA.json": 90212,
	"./LMIH.json": 32467,
	"./OG.json": 40707,
	"./VL.json": 39327
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 83576;